module.exports = {
      id: "icons:heart-usage",
      viewBox: "0 0 18 16",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#icons:heart-usage",
      toString: function () {
        return this.url;
      }
    }